import type { ReactNode } from 'react'

/**
 * `div.field` → `field` (process/08-COMPONENT-CATALOGUE.md). "A labelled form control." gap 5px
 * → --sp-3 (+1px delta); label font-size 11px → --fs-small (0 delta); label weight 600 →
 * --fw-semibold.
 *
 * The control is nested INSIDE the `<label>` (implicit label association, §33.1's WCAG 2.2 AA
 * "labelled fields") rather than the prototype's sibling markup with no `id`/`htmlFor` pair —
 * §33.1 is an MVP requirement design/ states explicitly, and it wins where it conflicts with
 * §24.2c's structural fidelity to the prototype. `OtpInput`'s six inputs each carry their own
 * `aria-label`, which takes precedence over the wrapping label's text for their accessible name.
 */
export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div data-cmp="field" className="flex flex-col gap-3">
      <label>
        <span className="block mb-3 text-small font-semibold text-tx2">{label}</span>
        {children}
      </label>
    </div>
  )
}
